import { connect } from 'react-redux';
import React, { PropTypes } from 'react';
import { updateExistingState } from '../actions/form';
import { getErrors, getExistingState } from '../reducers/form';
import cx from 'classnames';
import { Button } from 'semantic-ui-react';

const mapStateToProps = state => ({
  existingState: getExistingState(state),
  errors: getErrors(state),
});
const mapDispatchToProps = dispatch => ({
  updateExistingState: event =>
    dispatch(updateExistingState(event.target.value)),
});

const ExistingCaseState = ({ existingState, updateExistingState, errors }) => {
  const fieldClass = cx('field required', {
    error: errors.includes('existingState'),
  });

  return (
    <div className="ui segment">
      <div className="two fields">
        <div className={fieldClass}>
          <label>A quelle phase est votre chantier ?</label>
          <Button.Group>
            <Button
              type="button"
              positive={existingState === 'PREVENTION'}
              value="PREVENTION"
              onClick={updateExistingState}
            >
              Prévention
            </Button>
            <Button.Or text="ou" />
            <Button
              type="button"
              positive={existingState === 'ELIMINATION'}
              value="ELIMINATION"
              onClick={updateExistingState}
            >
              Elimination
            </Button>
            <Button.Or text="ou" />
            <Button
              type="button"
              positive={existingState === 'OBSERVATION'}
              value="OBSERVATION"
              onClick={updateExistingState}
            >
              Surveillance
            </Button>
          </Button.Group>
        </div>
        <div className="field" />
      </div>
    </div>
  );
};

ExistingCaseState.propTypes = {
  existingState: PropTypes.string.isRequired,
  updateExistingState: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(ExistingCaseState);



// WEBPACK FOOTER //
// ./src/modules/saas/aast/cases-creation/step1/components/ExistingCaseState.js